import { render } from "./GroupDeviceComponent.vue?vue&type=template&id=0293fa26"
import script from "./GroupDeviceComponent.vue?vue&type=script&lang=js"
export * from "./GroupDeviceComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__